export default (state = {}, action) => {
    switch (action.type) {
        case 'SET_MOVEIS':
            return action.moveis;
        case 'CRIAR_MOVEIS':
            return [...state, action.movel];
        case 'EDITAR_MOVEIS':
            return state.map((movel) => (
                (movel.id === action.movel.id) ? (
                    action.movel
                ) : (
                    movel
                    )
            ));
        case 'ELIMINAR_MOVEIS':
            return state.filter((movel) => (
                movel.id !== action.movelId
            ));
        default:
            return state;
    }
}